import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import { history } from 'containers/App';
import ClientSelectForm from 'components/ClientSelectForm';
import { proceedWithClient } from 'actions';
import withContainerErrorBoundary from 'components/ErrorBoundaries/ContainerErrorBoundary/withContainerErrorBoundary';

class ClientSelect extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    clients: PropTypes.arrayOf(PropTypes.shape()),
    selectedClient: PropTypes.shape({})
  };

  static defaultProps = {
    clients: [],
    selectedClient: null
  };

  constructor(props) {
    super(props);

    this.state = {
      errorMessage: null
    };

    const { selectedClient } = this.props;
    if (selectedClient != null) {
      history.push('/');
    }
  }

  async proceedWithClient(client) {
    if (client.clientId == null) {
      this.setState({ errorMessage: { message: 'Please select a valid client' } });
    } else {
      const { dispatch, clients } = this.props;
      const selectedClient = clients.find(keyId => keyId.key === parseInt(client.clientId, 10));
      await dispatch(proceedWithClient(selectedClient));
      history.push('/');
    }
  }

  resetErrorMessage() {
    this.setState({ errorMessage: null });
  }

  render() {
    const { errorMessage } = this.state;
    const { clients } = this.props;

    return (
      <div className="login-container">
        <ClientSelectForm
          allClients={ clients }
          errorMessage={ errorMessage }
          onSubmit={ client => this.proceedWithClient(client) }
          onCloseErrorMessage={ () => this.resetErrorMessage() }
        />
      </div>
    );
  }
}

// eslint-disable-next-line consistent-return
const mapStateToProps = (state) => {
  if (state.auth && state.auth.settings) {
    const {
      auth: {
        settings: {
          clients,
          selectedClient
        }
      },
    } = state;
    return {
      clients,
      selectedClient
    };
  }
};

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withContainerErrorBoundary(ClientSelect, 'ClientSelect'));
